import { RequestType } from 'models/productsReferential';
import { defaultBatchFormRequestedThunk } from 'state/batchForm/batchForm.thunks';
import {
  generateEnrichmentForField,
  isFieldMetadataUsableInMultipleApply,
  isFieldValueValid,
} from 'state/batchForm/multipleApply';
import { formEnrichmentRequested } from 'state/formData/formData.action';
import {
  getBatchFormFieldMetadata,
  getFormEnrichedData,
  getMultipleBatchApplyFieldsActions,
  getMultipleBatchApplyFieldsData,
  getSelectedFormIdsInBatchTab,
} from 'state/selectors';
import type { Thunk } from 'state/state.common';
import { isXMarginValueApplicable } from 'state/workspaces/batch/tabContent/tabContent.helpers';
import { workspaceTabProductSelectionSubmitted, workspaceTabRenamed } from 'state/workspaces/workspace.actions';

import { batchWorkspaceProductSelected } from './tabContent.actions';

export function batchWorkspaceTabProductSelectionSubmittedThunk(
  tabId: string,
  productType: string,
  productSubType: string,
  wrapper: string,
  requestType?: RequestType,
  payoffType: string | undefined = undefined,
  tabName?: string,
  isReprice: boolean = false,
): Thunk<void> {
  return dispatch => {
    dispatch(
      workspaceTabProductSelectionSubmitted(
        tabId,
        {
          productType,
          productSubType,
          wrapper,
          payoffType,
          requestType,
        },
        null,
        'newBatch',
      ),
    );
    if (tabName) {
      dispatch(workspaceTabRenamed(tabId, tabName, 'newBatch'));
    }
    if (!isReprice) {
      dispatch(defaultBatchFormRequestedThunk(tabId, productType, productSubType, wrapper, payoffType));
    }
  };
}

/**
 * @deprecated
 */
export function batchWorkspaceProductSelectedThunk(
  tabId: string,
  productType: string,
  productSubType: string,
  wrapper: string,
  payoffType: string | undefined = undefined,
  tabName?: string,
  isReprice: boolean = false,
): Thunk<void> {
  return dispatch => {
    dispatch(batchWorkspaceProductSelected(tabId, productType, productSubType, wrapper, payoffType));
    if (tabName) {
      dispatch(workspaceTabRenamed(tabId, tabName, 'newBatch'));
    }
    if (!isReprice) {
      dispatch(defaultBatchFormRequestedThunk(tabId, productType, productSubType, wrapper, payoffType));
    }
  };
}

export function applyMultipleBatchThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const selectedFormIds = getSelectedFormIdsInBatchTab(state, tabId);
    const fieldsToEnrich = Object.entries(getMultipleBatchApplyFieldsData(state, tabId));
    const updateActions = getMultipleBatchApplyFieldsActions(state, tabId);
    selectedFormIds.forEach(formId => {
      const formMetadata = getBatchFormFieldMetadata(state, formId);
      const formData = getFormEnrichedData(state, formId);
      const filteredFieldsToEnrich = fieldsToEnrich
        .filter(
          ([fieldName, fieldValue]) =>
            isFieldMetadataUsableInMultipleApply(formMetadata[fieldName]) &&
            isFieldValueValid(fieldValue, formMetadata[fieldName]) &&
            isXMarginValueApplicable(fieldName, fieldValue, formData),
        )
        .map(([fieldName, fieldValue]) => {
          const newValue = generateEnrichmentForField(
            formMetadata[fieldName],
            updateActions[fieldName],
            fieldValue,
            formData[fieldName],
          );
          return [fieldName, newValue ?? fieldValue] as const;
        });
      if (filteredFieldsToEnrich.length > 0) {
        dispatch(formEnrichmentRequested(tabId, formId, Object.fromEntries(filteredFieldsToEnrich), 'newBatch'));
      }
    });
  };
}
